import gql from 'graphql-tag';

export default ({ topupId }) => {
  return gql`
      query {
          getTopUpReceipt(topupId: "${topupId}")
      }
  `;
};
